import actuMock from "@/mock/actu.json";
import allActualites from "@/mock/actualites.json";
import {actualite, detailActualite} from "@/types/actualite";

import {getDataMock} from "./_callApi";

export async function getActualites(): Promise<actualite[]> {
  if (getDataMock()) {
    const actualite: actualite[] = allActualites;
    return actualite;
  } else {
    const actualite: actualite[] = allActualites;
    return actualite;
  }
}

export async function getActualite(id: string): Promise<detailActualite> {
  console.log(id);
  if (getDataMock()) {
    const actualite: detailActualite = actuMock;
    return actualite;
  } else {
    const actualite: detailActualite = actuMock;
    return actualite;
  }
}
